import { observer } from "mobx-react";
import { h } from "preact";
import { t, translate } from "restaumatic-client";
import ButtonPrice from "../../components/ButtonPrice";
import ShortForOrderAlert from "../../components/ShortForOrderAlert";
import { CART_MODAL_ID, showModal, switchModals } from "../../utils/Modals";
const CROSS_SELLING_BOTTOM_SHEET_ID = "cross-selling-cart";
function CartFooter(props) {
    const { price, isContinueVisible, isSubmitDisabled, isSubmitLoading, shortForOrderAlert, onContinue, onSubmit, } = props;
    const handleAlertClick = () => {
        var _a;
        const currentlyFocusedElement = (_a = document.activeElement) !== null && _a !== void 0 ? _a : undefined;
        void switchModals(CART_MODAL_ID, CROSS_SELLING_BOTTOM_SHEET_ID).then((result) => {
            if (result) {
                void result.hidden.then(() => {
                    void showModal(CART_MODAL_ID).then(() => currentlyFocusedElement === null || currentlyFocusedElement === void 0 ? void 0 : currentlyFocusedElement.focus());
                });
            }
        });
    };
    return (h("div", { class: "modal-footer modal-footer--sticky", "data-field-id": "Cart.footer" },
        h(ShortForOrderAlert, { shortForOrderAlert: shortForOrderAlert, bottomSheetId: CROSS_SELLING_BOTTOM_SHEET_ID, onClick: handleAlertClick }),
        h("div", { class: "modal-footer__actions" },
            isContinueVisible && (h("button", { onClick: onContinue, class: "btn btn-default continue-shopping", type: "button", "data-ga-action": "Close cart (continue shopping clicks)", "data-testid": "cart/continueShopping", "data-field-id": "Cart.continueShopping" }, translate(t.restaurants.widgets.cart.hide))),
            " ",
            h("button", { onClick: onSubmit, class: `btn checkout btn-checkout ${isSubmitDisabled && "disabled"}`, type: "button", "data-testid": "Cart/submit", "data-field-id": "Cart.checkout", disabled: isSubmitLoading },
                isSubmitLoading && (h("i", { class: "icon-btn icon-spinner icon-spin u-mr1", "aria-hidden": "true" })),
                translate(t.restaurants.widgets.cart.checkout),
                h(ButtonPrice, { dataFieldId: "Cart.price", price: price })))));
}
export default observer(CartFooter);
